import { render, staticRenderFns } from "./addCard.vue?vue&type=template&id=c49b4e12&scoped=true&"
import script from "./addCard.vue?vue&type=script&lang=js&"
export * from "./addCard.vue?vue&type=script&lang=js&"
import style0 from "./addCard.vue?vue&type=style&index=0&id=c49b4e12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49b4e12",
  null
  
)

export default component.exports